<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform" xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div class="mt-3">
         <v-alert type="info">
                    {{$t('templates.description')}}
                 </v-alert>
        <h5 class="mb-4" style="font-weight: 200">Liste des templates de paiement.</h5>
        <v-card elevation="0" style="background: transparent!important;" class="marchandTemplate">
            <v-tabs v-model="api_tabs" style="background: #616161!important;">
                <v-tab>{{$t('templates.mine')}}</v-tab>
                <v-tab>{{$t('templates.newfree')}}</v-tab>
                <v-tab>{{$t('templates.newnotfree')}}</v-tab>
            </v-tabs>
            <v-tabs-items  v-model="api_tabs" style="background: transparent!important;">
                <v-tab-item>
                    <v-text-field v-if="templatemines===undefined" color="primary" loading
                                  disabled></v-text-field>
                    <v-alert
                            style="margin-top: 1%"
                            v-else-if="templatemines.length==0"
                            border="right"
                            colored-border
                            type="error"
                            elevation="2"
                    >
                        {{$t('templates.minenot')}}
                    </v-alert>
                    <div class="row">
                        <div class="col-12 col-md-4 col-lg-3" style="text-align: center" v-for="(theme, index) in templatemines" v-bind:key="index" >
                            <v-card :id="theme._id" class="ma-1 pa-6 chooseAll" tile outlined style="background: #fff!important; text-align: center;border-radius: 0px!important;border: none!important;">
                                 <div class="row">
                                  <div class="col-lg-12">
                                      <img  @click="showImage('/'+theme._image,theme._name)" v-lazy="'/'+theme._image" alt="" style="margin-top:10px;  max-height: 100px;cursor: pointer;width:100%">
                                  </div>
                                  <div class="col-lg-12">
                                 <h3 style="margin-top: 5%; font-weight: 500;">
                                   {{limiText(theme._name,7)}}
                                </h3>
                               
                                <div class="col-lg-12 text-center mt-3">
                                    <a href="#" @click="deleteItem(theme)" class="btn btn-sm btn-light">
                                        Retirer
                                </a> 
                                </div>
</div>
                              </div>
                               </v-card>
                        </div>
                    </div>
                </v-tab-item>
                <v-tab-item>
                     <v-text-field v-if="templatefrees===undefined" color="primary" loading
                                  disabled></v-text-field>
                    <v-alert
                            style="margin-top: 1%"
                            v-else-if="templatefrees.length==0"
                            border="right"
                            colored-border
                            type="error"
                            elevation="2"
                    >
                        {{$t('templates.free')}}
                    </v-alert>
                    <div class="row">
                        <div class="col-12 col-md-4 col-lg-3"
                             style="text-align: center" v-for="(theme, index) in templatefrees" v-bind:key="index" >
                            <v-card :id="theme._id" class="ma-1 pa-6 chooseAll" outlined tile style="background: #fff!important; text-align: center;border-radius: 0px!important;border: none!important;">
                                  <div class="row">
                                  <div class="col-lg-12">
                                      <img  @click="showImage('/'+theme._image,theme._name)" v-lazy="'/'+theme._image" alt="" style="margin-top:10px;  max-height: 100px;cursor: pointer;width:100%">
                                  </div>
                                  <div class="col-lg-12">
                                 <h3 style="margin-top: 5%; font-weight: 200;">
                                  {{limiText(theme._name,7)}}
                                </h3>
                               
                                <div class="col-lg-12 text-center mt-3">
                                    <a href="#" @click="saveItem(theme)" class="btn btn-sm btn-light">
                                        Ajouter
                                    <!-- <v-icon style="color: #29b3a6;margin-top:0">mdi mdi-plus-circle-outline</v-icon> -->
                                </a> 
                                </div>
</div>
                              </div>
                            </v-card>
                        </div>
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <v-text-field v-if="templatenotfrees===undefined" color="primary" loading
                                  disabled></v-text-field>
                    <v-alert
                            style="margin-top: 1%"
                            v-else-if="templatenotfrees.length==0"
                            border="right"
                            colored-border
                            type="error"
                            elevation="2">
                        {{$t('templates.freenot')}}
                    </v-alert>
                    <div class="row">
                        <div class="col-12 col-md-4 col-lg-3"
                             style="text-align: center"
                             v-for="(theme, index) in templatenotfrees" v-bind:key="index" >
                            <v-card :id="theme._id" class="ma-1 pa-2 chooseAll" outlined tile style="background: #fff!important; text-align: center;border-radius: 0px!important;border: none!important;">
                              <div class="row">
                                  <div class="col-lg-12">
                                      <img  @click="showImage('/'+theme._image,theme._name)" v-lazy="'/'+theme._image" alt="" style="margin-top:10px;  max-height: 100px;cursor: pointer;width:100%">
                            
                                  </div>
                                  <div class="col-lg-12">
                                 <h3 style="margin-top: 5%; font-weight: 500;">
                                   {{limiText(theme._name,7)}}
                                </h3>
                                <div class="text-center" style="margin-bottom: 5%;">
                                    <span style="padding: 5px 15px!important;border-radius: 10px;background: #fda43e"> {{theme._amount}} $</span>
                                </div>
                                <div class="text-center col-12">
                                    <a href="#" @click="saveItem(theme)" class="btn btn-sm btn-light">
                                        Acheter
                                    <!-- <v-icon style="color: #29b3a6;margin-top:0">mdi mdi-plus-circle-outline</v-icon> -->
                                </a> 
                                </div>
</div>
                              </div>
                                
                            </v-card>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <template >
          <v-toolbar flat color="white">
              <v-dialog v-model="dialogShowImg" max-width="300px">
                  <v-card style="">
                      <v-card-title>
                          <v-btn color="light" style="padding:0!important" icon @click="dialogShowImg = false"><i class="mdi mdi-close-circle"></i></v-btn>
                      </v-card-title>
                      <v-card-text>
                          <img v-lazy="link" style="width: 250px;" alt="">
                      </v-card-text>
                      <v-card-actions>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
          </v-toolbar>
      </template>
        <template>
            <div class="text-center ma-2">
                <v-snackbar v-model="snackbar">
                    {{ text }}
                    <template v-slot:action="{ attrs }">
                        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
                            {{$t("fermer")}}
                        </v-btn>
                    </template>
                </v-snackbar>
            </div>
        </template>

    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'
    import helpers from "../../../../../mixins/helpers";
    import VueClipboard from 'vue-clipboard2'
    VueClipboard.config.autoSetContainer = true;
    import countries from '../../../../../resources/countries.json'
    import $ from 'jquery'
    export default {
        components: {
            CountryFlag, VueClipboard
        },
        mixins:[helpers(this)],
        label: "Pays",
        data() {
            return {
                api_tabs:null,
                submitting: false,
                valid: true,
                snackbar: false,
                dialogShowImg: false,
                link:"",
                nametheme:'',
                text: "",
                lazy: false,
                search: '',
                dialog: false,
                id: undefined,
                errors:undefined,
                headers: [
                    {text: 'Drapeau', value: '_flag'},
                    {
                        text: 'Nom',
                        align: 'start',
                        sortable: true,
                        value: '_name',
                    },
                    {text: 'Code', value: '_code'},
                    {text: 'Préfixe', value: '_code_iso_numerique'},
                    {text: 'Actions', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    _name: '',
                    _code: '',
                    _file: '',
                    _code_iso_numerique: '',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _name: '',
                    _code: '',
                    _flag: '',
                    _code_iso_numerique: '',
                    _id: 0,
                    _created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || 'Code requis',
                ],
                code_iso_numeriqueRules: [
                    v => !!v || 'Code iso requis',
                ],
                actions_items: [
                    { title: "Régions", avatar: 'mdi mdi-view-list' },
                    { title: "Modifier", avatar: 'mdi-pencil' },
                    { title: "Supprimer", avatar: 'mdi-delete' }
                ],
            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('countries.new') : this.$t('countries.update')
            },
            ...mapState('templates/', ['templatemines','templatefrees','templatenotfrees'])
        }
        ,
        mounted() {
            this.$vuetify.goTo(0)
            $(document).scrollTop()
            this.$store.dispatch('templates/getMarchandTemplate').then(response => {});
            this.$store.dispatch('templates/getMarchandTemplateFree').then(response => {});
            this.$store.dispatch('templates/getMarchandTemplateNotFree').then(response => {});
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },

            showImage(img,name){
              this.link = img;
              this.nametheme = name;
              this.dialogShowImg = true;
            },
            onCopy: function (e) {
                this.text = this.$t("copie")+ e.text;
                this.snackbar = true;
            },
            onError: function (e) {
                this.text = this.$t("copiefailed");
                this.snackbar = true;
            },

            deleteItem(item) {


                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: this.$t('delete'),
                    cancelButtonText: this.$t('cancel'),
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29B3A6"
                })
                    .then(result => {
                        if (result.value) {
                            let data = new FormData();
                            data.append("template", item._id);
                            data.append("type", "remove");
                            console.log("template", item._id);
                            let mineroute = 'templates/setAddTemplate';
                            this.$store.dispatch(mineroute, data).then((response) => {
                                if (response.error) {
                                    VueBox.errors.operation = response.message;
                                } else {
                                    VueBox.close();
                                }
                            })
                        }
                    })
            },
            saveItem(item) {

                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('templates.addText'),
                    confirmButtonText: this.$t('ajouter'),
                    cancelButtonText: this.$t('cancel'),
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29B3A6"
                })
                    .then(result => {
                        if (result.value) {
                            let data = new FormData();
                            data.append("template", item._id);
                            data.append("type", "add");
                            console.log("template", item._id);
                            let mineroute = 'templates/setAddTemplate';
                            this.$store.dispatch(mineroute, data).then((response) => {
                                if (response.error) {
                                    VueBox.errors.operation = response.message;
                                } else {
                                    VueBox.close();
                                }
                            })
                        }
                    })

            },

            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code)
                }
            },
            getColor(calories) {
                if (calories > 230) return 'red'
                else if (calories > 200) return 'orange'
                else return 'green'
            },
            setCountryDetails(){
                let country =  countries.find(country=> country.iso2 == this.editedItem._code);
                this.editedItem._name = country.name;
                this.editedItem._code_iso_numerique = country.phone_code;
            },

        },

        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>
.chooseAll{
    background: white!important;
}
</style>
